import { useMemo } from 'react';
import { useUserPolicyContext } from '../context/UserPolicy';
import { useUserStatusContext } from '../context/UserStatus';
import useShowMonthlyCare from '../pages/MonthlyCare/useShowMonthlyCare';

const useGetUserMenuLinks = () => {
    const { permissions } = useUserStatusContext();
    const { orgProperties } = useUserPolicyContext();
    const showMonthlyCare = useShowMonthlyCare();

    return useMemo(() => {
        return [
            {
                to: '/members',
                label: 'Members',
                // Care Manager + Care Manager Supervisor reach Members via member-view (they lack
                // org-level fleetListView). Permission-based so it's correct per active org.
                show: permissions.fleet.fleetListView || permissions.fleet.fleetMemberView
            },
            {
                to: '/form-fills',
                label: 'Form fills',
                show: permissions.leads.leadListView
            },
            {
                to: '/users',
                label: 'Users',
                show: permissions.iam.listInvites
            },
            {
                to: '/reports',
                label: 'Reports',
                // Org-level Reports: admins/standard/read-only hold fleetListView; Care Manager +
                // Supervisor (member-scoped only) do not, so it's hidden for them.
                show: orgProperties?.has_device_activity_report && permissions.fleet.fleetListView
            },
            {
                to: '/monthly-care',
                label: 'Monthly Care',
                show: showMonthlyCare
            },
            {
                to: '/our-performance',
                label: 'Our Performance',
                show: permissions.kpiReports.kpiReportsView
            }
        ];
    }, [permissions, orgProperties, showMonthlyCare]);
};

export default useGetUserMenuLinks;
